"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [0, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Text = function (_super) {
  __extends(Text, _super);

  function Text(props) {
    var _this = _super.call(this, props) || this;

    var value = props.value || "";

    var isValid = _this.validate(value, props);

    _this.state = {
      value: value,
      isValid: isValid,
      showError: false
    };
    _this.onChange = _this.onChange.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  Text.prototype.componentWillReceiveProps = function (nextProps) {
    var value = nextProps.value || this.state.value || "";
    this.setState({
      value: value
    });
  };

  Text.prototype.validate = function (value, props) {
    if (props === void 0) {
      props = this.props;
    }

    var required = props.required,
        validateFn = props.validateFn,
        password = props.password;
    var isValid = true;

    if (required) {
      if (validateFn) {
        isValid = validateFn(value);
      } else {
        isValid = value.length > 0;
      }
    } else if (password) {
      isValid = value.length >= 6;
    } else if (value.length > 0) {
      if (!!validateFn) {
        isValid = validateFn(value);
      }
    }

    return isValid;
  };

  Text.prototype.onChange = function (event) {
    return __awaiter(this, void 0, void 0, function () {
      var value, cursor, isValid, _a, context, field, input;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            value = event.currentTarget.value;
            cursor = event.target.selectionStart;
            isValid = this.validate(value);
            if (!isValid) return [3
            /*break*/
            , 2];
            _a = this.props, context = _a.context, field = _a.field;
            return [4
            /*yield*/
            , context.onValue(field, value, true)];

          case 1:
            _b.sent();

            _b.label = 2;

          case 2:
            return [4
            /*yield*/
            , this.setState({
              value: value,
              showError: false
            })];

          case 3:
            _b.sent();

            input = this.refs.input;
            input.setSelectionRange(cursor, cursor);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Text.prototype.onBlur = function () {
    return __awaiter(this, void 0, void 0, function () {
      var value, error, isValid;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            value = this.state.value;
            error = this.props.error;
            isValid = this.validate(value);
            if (!isValid) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.setState({
              showError: false
            })];

          case 1:
            _a.sent();

            return [3
            /*break*/
            , 4];

          case 2:
            return [4
            /*yield*/
            , this.setState({
              showError: true
            })];

          case 3:
            _a.sent();

            _a.label = 4;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  Text.prototype.render = function () {
    var props = this.props;
    var label = "";

    if (props.label) {
      var className = props.required ? "required" : "";
      label = React.createElement("label", {
        className: className
      }, props.label);
    }

    var classNames = this.props.className ? this.props.className.split(' ') : [];
    var value = this.state.value;
    var maxLength = props.maxLength;

    if (this.state.showError) {
      classNames.push("invalid");
    }

    var charsRemain = maxLength - value.length;
    var charClasses = ["char-count"];

    if (charsRemain < 80) {
      charClasses.push("visible");
    }

    if (charsRemain < 20) {
      charClasses.push("warning");
    }

    var errorMessage = this.props.error || "Incorrect format";

    if (this.props.multiline) {
      return React.createElement("div", {
        className: "input"
      }, label, React.createElement("textarea", {
        className: classNames.join(" "),
        placeholder: this.props.placeholder,
        maxLength: this.props.maxLength,
        value: value,
        ref: "input",
        onChange: this.onChange,
        onBlur: this.onBlur
      }), React.createElement("span", {
        className: charClasses.join(" "),
        style: {
          "float": "right"
        }
      }, this.props.maxLength - value.length), React.createElement("span", {
        className: "error"
      }, errorMessage));
    } else {
      return React.createElement("div", {
        className: "input"
      }, label, React.createElement("input", {
        ref: "input",
        type: props.password ? "password" : "text",
        className: classNames.join(" "),
        placeholder: this.props.placeholder,
        value: value,
        onChange: this.onChange,
        onBlur: this.onBlur
      }), React.createElement("span", {
        className: "error"
      }, errorMessage));
    }
  };

  return Text;
}(React.Component);

exports["default"] = Text;